/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  createStyles, Progress,
} from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { IconRun, IconPennantFilled } from '@tabler/icons-react';
import { STEP_PROGRESS_MOVEMENT } from '../../utils/constants';

type OnboardingProgressProps = {
  progress: number
};

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    container: {
      width: '100%',
      padding: '4px 0px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
    },
    wrapper: {
      width: '100%',
      display: 'flex',
    },
    marker: {
      borderRadius: '50%',
      position: 'absolute',
    },
    bar: {
      backgroundColor: colors.primary.default,
    },
    root: {
      backgroundColor: colors.primary.muted,
      position: 'relative',
      width: '100%',
    },
    flag: {
      width: 50,
    },
  };
});

export const OnboardingProgress = (props: OnboardingProgressProps) => {
  const { classes } = useStyles();
  const { progress } = props;
  const [progressValue, setProgressValue] = useState(progress >= 9 ? progress - STEP_PROGRESS_MOVEMENT : progress);
  const [initialLoad, setInitialLoad] = React.useState(true);
  useEffect(() => {
    setInitialLoad(false);
  }, []);
  useEffect(() => {
    if (initialLoad !== true) {
      setTimeout(() => {
        setProgressValue(progress + STEP_PROGRESS_MOVEMENT);
      }, 200);
    } else {
      setProgressValue(progress);
    }
  }, [progress]);
  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <Progress
          value={progressValue}
          classNames={{
            bar: classes.bar,
            root: classes.root,
          }}
        />
        {/* <div className={classes.marker} style={{ left: `calc(${progressValue}% - 7.5px)` }}>
          <IconRun />
        </div> */}
      </div>
      {/* <IconPennantFilled size={30} /> */}
    </div>
  );
};

export default OnboardingProgress;
